export default "__VITE_ASSET__2291c5d1__"